var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconListDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6440_11783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0012 17.5C14.1439 17.5 17.5023 14.1421 17.5023 10C17.5023 5.85786 14.1439 2.5 10.0012 2.5C5.85838 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85838 17.5 10.0012 17.5Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3234 9.9998L13.4706 7.85293C13.8363 7.4873 13.8363 6.89668 13.4706 6.53105C13.105 6.16543 12.5142 6.16543 12.1486 6.53105L10.0014 8.67793L7.85415 6.53105C7.48847 6.16543 6.89775 6.16543 6.53207 6.53105C6.16639 6.89668 6.16639 7.4873 6.53207 7.85293L8.67928 9.9998L6.53207 12.1467C6.16639 12.5123 6.16639 13.1029 6.53207 13.4686C6.7196 13.6561 6.95401 13.7404 7.1978 13.7404C7.44159 13.7404 7.676 13.6467 7.86353 13.4686L10.0107 11.3217L12.1579 13.4686C12.3455 13.6561 12.5799 13.7404 12.8237 13.7404C13.0675 13.7404 13.3019 13.6467 13.4894 13.4686C13.8551 13.1029 13.8551 12.5123 13.4894 12.1467L11.3422 9.9998H11.3234Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6440_11783"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.0023,
    height: 15,
    fill: "white",
    transform: "translate(2.5 2.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconListDelete);
export default __webpack_public_path__ + "static/media/Icon-List-Delete.11bde281.svg";
export { ForwardRef as ReactComponent };